import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Api } from "../../../../services/api";
import { RoomFormType } from "./roomSchema";
import { Office, OfficeRoom } from "../../../../services/api/types/Offices";
import { OfficeStatus } from "../../../../enums";
import { RoomForm, RoomFormHeader } from "../RoomForm";

export const AddRoom = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [office, setOffice] = useState<Office>();
  const history = useHistory();
  const { officeId } = useParams<{ officeId: string }>();

  useEffect(() => {
    fetchOffice();
  }, [officeId]);

  const fetchOffice = async () => {
    try {
      const response = await Api.offices.getOffice(officeId);
      response.data.status = OfficeStatus[response.data.status as number];
      setOffice(response.data);
      setIsLoading(false);
    } catch (e) {
      console.error("Fetch Office Error:", e);
    }
  };

  const submitValues = (values: RoomFormType) => {
    const data: OfficeRoom = {
      id: "",
      name: values.roomName || "",
      officeNumber: values.roomNumber || 0,
      computerNumber: values.computerNumber || "",
      computerPassword: values.computerPassword || "",
      computerUserName: values.computerUserName || "",
      hasAppleTv: values.hasAppleTv === "Yes",
      hasHdmi: values.hasHdmi === "Yes",
    };
    try {
      Api.offices.createOfficeRoom(officeId, data).then(res => {
        const currentLocation = history.location;
        currentLocation.pathname =
          currentLocation.pathname.split("/").slice(0, -1).join("/") +
          `/editRoom/${res.data.id}`;
        history.push(currentLocation);
      });
    } catch (error) {
      console.error("Update Team Member:", error);
    }
  };

  return (
    <>
      {!isLoading && office && (
        <RoomForm
          header={RoomFormHeader.add}
          submitValues={submitValues}
          office={office}
        />
      )}
    </>
  );
};
